import { takeLatest, call, put } from "redux-saga/effects";
import api from "Util/api";

const types = {
    GET_DEGREES_REQUESTED: "GET_DEGREES_REQUESTED",
    GET_DEGREES_SUCCEEDED: "GET_DEGREES_SUCCEEDED",
    GET_DEGREES_FAILED: "GET_DEGREES_FAILED"
};

export const actions = {
    getDegrees: () => {
        return {
            type: types.GET_DEGREES_REQUESTED
        };
    }
};

const defaultState = {
    data: [],
    error: "",
    loading: true
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.GET_DEGREES_REQUESTED:
            return {
                ...state,
                loading: true
            };
        case types.GET_DEGREES_SUCCEEDED:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        case types.GET_DEGREES_FAILED:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        default:
            return state;
    }
}

export function* saga() {
    yield takeLatest(types.GET_DEGREES_REQUESTED, startGetDegreesWorker);
}

// Saga callback
function* startGetDegreesWorker() {
    try {
        const response = yield call(getDegrees);

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.GET_DEGREES_SUCCEEDED,
            payload: response.data
        });
    } catch (e) {
        yield put({ type: types.GET_DEGREES_FAILED, payload: e.error });
    }
}

function getDegrees() {
    return api.get("/api/subject-profile/degrees");
}
